<div class="leave-content" [ngClass]="[
      isLeave ? 'is-leave' : '',
      blinking ? blinkClass : '',
      data.isWarning && data.isHighlightRecord ? 'user-blinking' : '',
      data.isWarning && !data.isHighlightRecord ? 'warning-highlight' : ''
     ]">
  <label >{{data.value}}</label>
</div>
